var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.974 39.9782C77.0923 36.1753 71.7707 36.0302 69.0624 38.6836L59.8122 47.7461C59.0725 48.4707 57.8854 48.4586 57.1607 47.7189C56.436 46.9792 56.4482 45.792 57.1879 45.0674L66.438 36.0049C71.0279 31.5082 78.7223 32.5224 83.5983 37.2996C88.4812 42.0834 89.5444 49.6884 84.9198 54.2192L77.6518 61.3397C76.9121 62.0644 75.725 62.0523 75.0003 61.3126C74.2756 60.5729 74.2877 59.3857 75.0274 58.6611L82.2954 51.5405C84.969 48.9212 84.8489 43.7745 80.974 39.9782Z",
    fill: "#F57E20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5601 38.9603C46.9857 38.0987 45.8216 37.8659 44.96 38.4403C44.0983 39.0147 43.8655 40.1788 44.4399 41.0405L49.4399 48.5405C50.0143 49.4021 51.1785 49.6349 52.0401 49.0605C52.9017 48.4861 53.1345 47.3219 52.5601 46.4603L47.5601 38.9603Z",
    fill: "#F57E20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5929 48.2216C35.6106 47.8941 34.5487 48.4251 34.2212 49.4075C33.8938 50.3899 34.4247 51.4517 35.4071 51.7792L50.4071 56.7792C51.3895 57.1066 52.4513 56.5757 52.7788 55.5933C53.1063 54.6109 52.5753 53.5491 51.5929 53.2216L36.5929 48.2216Z",
    fill: "#F57E20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8189 61.2654C48.5175 60.501 48.4642 59.315 47.6999 58.6164C46.9355 57.9178 45.7495 57.9711 45.0509 58.7354L41.8988 62.1841C37.5817 66.9074 38.5246 74.8174 43.1596 79.8884C47.8225 84.99 55.3357 86.149 59.7972 81.2679L69.884 70.2319C70.5826 69.4676 70.5294 68.2816 69.765 67.5829C69.0006 66.8843 67.8146 66.9376 67.116 67.702L57.0292 78.7379C54.527 81.4755 49.621 81.3993 45.9276 77.3585C42.2063 73.2871 42.0203 67.6095 44.6668 64.7141L47.8189 61.2654Z",
    fill: "#F57E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionError);
export default __webpack_public_path__ + "static/media/connection-error.856ea7b469a8f3fb3dcaaf88f47885be.svg";
export { ForwardRef as ReactComponent };